export const MICROSOFT_KEY = process.env.REACT_APP_MICROSOFT_KEY;
